var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5452 15.7727V13.0455C24.5452 7.77364 20.2716 3.5 14.9998 3.5C9.72796 3.5 5.45432 7.77364 5.45432 13.0455V15.7727H2.72705V33.5H27.2725V15.7727H24.5452ZM8.1816 13.0455C8.1816 9.28591 11.2402 6.22727 14.9998 6.22727C18.7593 6.22727 21.818 9.28591 21.818 13.0455V15.7727H8.1816V13.0455ZM24.5452 30.7727H5.45432V18.5H24.5452V30.7727Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6359 24.7849V28.0433H16.3632V24.7849C16.7791 24.4106 17.045 23.874 17.045 23.2706C17.045 22.1408 16.1293 21.2252 14.9996 21.2252C13.8698 21.2252 12.9541 22.1408 12.9541 23.2706C12.9541 23.874 13.22 24.4106 13.6359 24.7849Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.fbe600c52988512194e5673bcec7b6c4.svg";
export { ForwardRef as ReactComponent };